class SectionProductGraphene extends HTMLElement {
  constructor() {
    super();
    this.tabheading = this.querySelectorAll('.tabheading_btn');
    this.tabdetails = this.querySelectorAll('.sec-Section_Inner__soh');

    if (!this.tabheading.length) return;

    this.init();
  }

  init() {
    graphenehc.load({
      elements: [
        { id: "you_may_also_like_2", target: "#recs1" },
        { id: "more_from_this_range", target: "#recs2" },
        { id: "complete_the_look", target: "#recs3" }
      ],
      init: () => {},
      success: (response) => {
        this.onGrapheneLoadSuccess();
      }
    });
  }

  onGrapheneLoadSuccess() {
    const options = {
      "cellAlign": "left",
      "groupCells": true,
      "contain": true,
      "WatchCSS": true,
      "pageDots": false,
      "freeScroll": true
    };
    this.tabInit(options);
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }

  tabInit(options) {
    this.tabheading.forEach((tab) => {
      const tabContent = tab.getAttribute('data-id');
      const tabContentEle = this.querySelector(`#${tabContent}`);
      const tabContentEleSlider = tabContentEle?.querySelector('[data-acs-pcp]');
      if (tabContentEleSlider && !tabContentEleSlider.classList.contains('flickity-enabled')) {
        this.initializeFlickity(tabContentEleSlider, options);
      }
      tab.addEventListener("click", (e) => this.onTabClick(e, options));
    });
  }

  onTabClick(e, options) {
    const clickedTabContent = e.currentTarget.getAttribute('data-id');
    const clickedTabContentEle = this.querySelector(`#${clickedTabContent}`);
    const clickedTabContentEleSlider = clickedTabContentEle?.querySelector('[data-acs-pcp]');
    this.tabheading.forEach(item => item.classList.remove('active'));
    this.tabdetails.forEach(item => item.style.display = "none");
    e.currentTarget.classList.add('active');
    clickedTabContentEle.style.display = "block";
    if (clickedTabContentEleSlider && !clickedTabContentEleSlider.classList.contains('flickity-enabled')) {
      this.initializeFlickity(clickedTabContentEleSlider, options);
    } else {
      this.resizeFlickity(clickedTabContentEleSlider);
    }
  }
  
  initializeFlickity(sliderElement, options) {
    const flkty = new Flickity(sliderElement, options);
    setTimeout(() => flkty.resize(), 2000);
    window.addEventListener('resize', function() {flkty.resize()});
  }

  resizeFlickity(sliderElement) {
    const flkty = Flickity.data(sliderElement);
    if (flkty) {
      flkty.resize();
      setTimeout(() => flkty.resize(), 1000);
    }
  }

}

customElements.define('section-product', SectionProductGraphene);